import { createContext, useContext } from "react";
import translations from "./translations";

const I18nContext = createContext(null);

export const useTranslation = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useTranslation must be used within I18nProvider");
  }
  return context;
};

export const I18nProvider = ({ children, language = "tr" }) => {
  const lang = translations[language] ? language : "tr";

  const t = (key) => {
    return translations[lang]?.[key] || translations["tr"]?.[key] || key;
  };

  return (
    <I18nContext.Provider value={{ t, language: lang }}>
      {children}
    </I18nContext.Provider>
  );
};
